const dictionaryActionTypes = {
  STORE_BIG_STATIC_DICTIONARIES: 'STORE_BIG_STATIC_DICTIONARIES',
};

export default dictionaryActionTypes;
